(() => {
  'use strict';
  const configNode = document.getElementById('eshtry-config');
  const config = configNode ? JSON.parse(configNode.textContent || '{}') : {};
  const root = config.root || '/';
  const path = (suffix) => root + suffix;
  const money = (cents) => new Intl.NumberFormat(config.locale || 'ar-EG', { style: 'currency', currency: config.currency || 'EGP' }).format(cents / 100);
  const readStorage = (key, fallback) => { try { return JSON.parse(localStorage.getItem(key)) || fallback; } catch { return fallback; } };
  const writeStorage = (key, value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* Storage may be disabled. */ } };
  const escapeHTML = (text) => String(text ?? '').replace(/[&<>"']/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char]);
  const api = async (suffix, options = {}) => {
    const response = await fetch(path(suffix), { ...options, headers: { Accept: 'application/json', ...(options.headers || {}) } });
    const data = await response.json();
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : (typeof data.message === 'string' ? data.message : 'تعذر تنفيذ الطلب. جرّب تاني.'));
    return data;
  };
  const post = (suffix, data) => api(suffix, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });

  function updateThemeToggle() {
    const dark = document.documentElement.classList.contains('dark');
    document.querySelectorAll('[data-theme-toggle]').forEach((button) => {
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', dark ? 'الوضع الفاتح' : 'الوضع الداكن');
      button.title = dark ? 'الوضع الفاتح' : 'الوضع الداكن';
    });
  }
  updateThemeToggle();
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-theme-toggle]');
    if (toggle) {
      document.documentElement.classList.toggle('dark');
      try { localStorage.setItem('eshtry-theme', document.documentElement.classList.contains('dark') ? 'dark' : 'light'); } catch { /* Optional preference. */ }
      updateThemeToggle();
    }
    const searchToggle = event.target.closest('[data-mobile-search]');
    if (searchToggle) {
      const panel = document.querySelector('[data-mobile-search-panel]');
      if (panel) {
        panel.hidden = !panel.hidden;
        searchToggle.setAttribute('aria-expanded', String(!panel.hidden));
        if (!panel.hidden) panel.querySelector('input')?.focus();
      }
    }
  });

  function setupSliders(scope = document) {
    scope.querySelectorAll('[data-slider]').forEach((slider) => {
      if (slider.dataset.initialized) return;
      slider.dataset.initialized = 'true';
      const slides = Array.from(slider.querySelectorAll('[data-slide]'));
      const dots = Array.from(slider.querySelectorAll('[data-slide-dot]'));
      if (!slides.length) return;
      let index = 0;
      let timer;
      let stopped = false;
      let hovered = false;
      let focused = false;
      let pointerX = null;
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const schedule = () => {
        clearTimeout(timer);
        if (slides.length < 2 || stopped || hovered || focused || motion.matches || document.hidden || slider.dataset.autoplay !== 'true') return;
        timer = setTimeout(() => show(index + 1), 6000);
      };
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, position) => {
          const active = position === index;
          slide.classList.toggle('active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        dots.forEach((dot, position) => dot.setAttribute('aria-current', String(position === index)));
        schedule();
      };
      slider.querySelector('[data-slide-prev]')?.addEventListener('click', () => show(index - 1));
      slider.querySelector('[data-slide-next]')?.addEventListener('click', () => show(index + 1));
      dots.forEach((dot, position) => dot.addEventListener('click', () => show(position)));
      slider.querySelector('[data-slide-pause]')?.addEventListener('click', (event) => {
        stopped = !stopped;
        event.currentTarget.setAttribute('aria-pressed', String(stopped));
        event.currentTarget.setAttribute('aria-label', stopped ? 'تشغيل تلقائي' : 'إيقاف التشغيل التلقائي');
        schedule();
      });
      slider.addEventListener('mouseenter', () => { hovered = true; schedule(); });
      slider.addEventListener('mouseleave', () => { hovered = false; schedule(); });
      slider.addEventListener('focusin', () => { focused = true; schedule(); });
      slider.addEventListener('focusout', () => { setTimeout(() => { focused = slider.contains(document.activeElement); schedule(); }, 0); });
      slider.addEventListener('touchstart', (event) => { pointerX = event.changedTouches[0]?.clientX ?? null; }, { passive: true });
      slider.addEventListener('touchend', (event) => {
        const end = event.changedTouches[0]?.clientX;
        if (pointerX !== null && end !== undefined && Math.abs(end - pointerX) > 40) show(index + (end > pointerX ? 1 : -1));
        pointerX = null;
      }, { passive: true });
      document.addEventListener('visibilitychange', schedule);
      motion.addEventListener('change', schedule);
      show(0);
    });
  }
  setupSliders();
  document.addEventListener('shopify:section:load', (event) => setupSliders(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-slide]');
    if (slide) {
      const slider = slide.closest('[data-slider]');
      const position = Array.from(slider.querySelectorAll('[data-slide]')).indexOf(slide);
      slider.querySelector(`[data-slide-dot="${position}"]`)?.click();
    }
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.mega[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.querySelectorAll('.mega').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (menu.open) document.querySelectorAll('.mega[open]').forEach((other) => { if (other !== menu) other.open = false; });
    });
    menu.addEventListener('mouseenter', () => { if (window.matchMedia('(hover: hover)').matches) menu.open = true; });
    menu.addEventListener('mouseleave', () => { if (!menu.contains(document.activeElement)) menu.open = false; });
  });

  let wishlist = readStorage('eshtry-wishlist', []);
  if (!Array.isArray(wishlist)) wishlist = [];
  function syncWishlist() {
    document.querySelectorAll('[data-wish]').forEach((button) => {
      const selected = wishlist.includes(button.dataset.wish);
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', selected ? 'إزالة من المفضلة' : 'إضافة للمفضلة');
    });
    document.querySelectorAll('[data-wish-count]').forEach((badge) => { badge.textContent = String(wishlist.length); badge.hidden = wishlist.length === 0; });
  }
  syncWishlist();
  async function renderWishlist() {
    const grid = document.querySelector('[data-wishlist-grid]');
    if (!grid) return;
    const status = document.querySelector('[data-wishlist-status]');
    const empty = document.querySelector('[data-wishlist-empty]');
    grid.replaceChildren();
    if (status) status.textContent = '';
    if (empty) empty.hidden = wishlist.length > 0;
    const result = await Promise.allSettled(wishlist.map(async (handle) => {
      const product = await api(`products/${encodeURIComponent(handle)}.js`);
      const article = document.createElement('article');
      article.className = 'product-card';
      const image = product.featured_image ? `<img src="${escapeHTML(product.featured_image)}" alt="${escapeHTML(product.title)}" loading="lazy" width="600" height="600">` : '';
      article.innerHTML = `<a class="product-photo" href="${path('products/' + encodeURIComponent(handle))}">${image}</a><button type="button" class="btn icon wish" data-wish="${escapeHTML(handle)}" aria-pressed="true" aria-label="إزالة من المفضلة">♥</button><div class="product-info"><p class="muted">${escapeHTML(product.vendor)}</p><a class="product-title" href="${path('products/' + encodeURIComponent(handle))}">${escapeHTML(product.title)}</a><div class="price">${money(product.price)}</div><a class="btn add-btn" href="${path('products/' + encodeURIComponent(handle))}">اختار الخيارات</a></div>`;
      return article;
    }));
    result.forEach((value) => { if (value.status === 'fulfilled') grid.append(value.value); });
    if (status && result.some((value) => value.status === 'rejected')) status.textContent = 'بعض المنتجات مش متاحة دلوقتي. جرّب تاني لاحقًا.';
    syncWishlist();
  }
  renderWishlist().catch(() => {});
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-wish]');
    if (!button) return;
    const handle = button.dataset.wish;
    wishlist = wishlist.includes(handle) ? wishlist.filter((value) => value !== handle) : [...wishlist, handle];
    writeStorage('eshtry-wishlist', wishlist);
    syncWishlist();
    if (document.querySelector('[data-wishlist-grid]')) renderWishlist().catch(() => {});
  });

  const dialog = document.querySelector('[data-cart-dialog]');
  const cartBody = document.querySelector('[data-cart-body]');
  const cartStatus = document.querySelector('[data-cart-status]');
  let opener = null;
  let cartBusy = false;
  const lock = () => document.body.classList.toggle('body-lock', Boolean((dialog && !dialog.hidden) || document.querySelector('[data-filter-panel].open')));
  function closeCart() { if (dialog) { dialog.hidden = true; lock(); opener?.focus(); } }
  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach((badge) => { badge.textContent = cart.item_count; badge.hidden = cart.item_count === 0; });
    document.querySelectorAll('[data-cart-total], [data-drawer-total]').forEach((node) => { node.textContent = money(cart.total_price); });
    document.querySelectorAll('[data-checkout]').forEach((button) => { button.disabled = cart.item_count === 0; });
    if (!cartBody) return;
    cartBody.innerHTML = cart.items.length ? cart.items.map((item) => `<div class="cart-line"><a href="${escapeHTML(item.url)}">${item.image ? `<img src="${escapeHTML(item.image)}" alt="${escapeHTML(item.product_title)}" width="72" height="72">` : ''}</a><div class="cart-line-info"><a href="${escapeHTML(item.url)}">${escapeHTML(item.product_title)}</a>${item.variant_title ? `<small class="muted">${escapeHTML(item.variant_title)}</small>` : ''}<strong>${money(item.final_line_price)}</strong><div class="quantity-controls"><button type="button" class="btn" data-cart-key="${escapeHTML(item.key)}" data-cart-qty="${item.quantity + 1}" aria-label="زيادة الكمية">+</button><span>${item.quantity}</span><button type="button" class="btn" data-cart-key="${escapeHTML(item.key)}" data-cart-qty="${item.quantity - 1}" aria-label="تقليل الكمية">−</button><button type="button" class="btn" data-cart-key="${escapeHTML(item.key)}" data-cart-qty="0" aria-label="حذف المنتج">×</button></div>${(item.line_level_discount_allocations || []).map((discount) => `<small>${escapeHTML(discount.discount_application.title)} − ${money(discount.amount)}</small>`).join('')}</div></div>`).join('') : '<div class="empty">سلتك فاضية</div>';
  }
  const refreshCart = async () => { const cart = await api('cart.js'); renderCart(cart); return cart; };
  async function openCart(trigger) {
    if (!dialog) return;
    opener = trigger || document.activeElement;
    dialog.hidden = false;
    lock();
    dialog.querySelector('[data-cart-close]')?.focus();
    if (cartStatus) cartStatus.textContent = '';
    try { await refreshCart(); } catch (error) { if (cartStatus) cartStatus.textContent = error.message; }
  }
  document.addEventListener('click', async (event) => {
    const open = event.target.closest('[data-cart-open]');
    if (open) { event.preventDefault(); await openCart(open); }
    if (event.target.closest('[data-cart-close]') || event.target === dialog) closeCart();
    const change = event.target.closest('[data-cart-key]');
    if (!change || cartBusy) return;
    cartBusy = true;
    if (cartStatus) cartStatus.textContent = '';
    dialog?.querySelectorAll('[data-cart-key], [data-checkout]').forEach((button) => { button.disabled = true; });
    try { const cart = await post('cart/change.js', { id: change.dataset.cartKey, quantity: Number(change.dataset.cartQty) }); renderCart(cart); }
    catch (error) { if (cartStatus) cartStatus.textContent = error.message; await refreshCart().catch(() => {}); }
    finally { cartBusy = false; dialog?.querySelectorAll('[data-cart-key]').forEach((button) => { button.disabled = false; }); }
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (form.matches('[data-add-form]')) {
      event.preventDefault();
      if (form.dataset.busy) return;
      form.dataset.busy = 'true';
      const button = form.querySelector('[type=submit]');
      const status = form.querySelector('[data-form-status]');
      if (button) button.disabled = true;
      if (status) { status.textContent = ''; status.hidden = true; }
      try { await api('cart/add.js', { method: 'POST', body: new FormData(form) }); await openCart(button); }
      catch (error) { if (status) { status.hidden = false; status.textContent = error.message; } }
      finally { delete form.dataset.busy; if (button) button.disabled = false; }
    }
    if (form.matches('[data-discount-form]')) {
      event.preventDefault();
      const input = form.elements.namedItem('discount');
      const code = input?.value.trim() || '';
      if (!code || cartBusy) return;
      cartBusy = true;
      const button = form.querySelector('button');
      if (button) button.disabled = true;
      if (cartStatus) cartStatus.textContent = '';
      try {
        const cart = await post('cart/update.js', { discount: code });
        renderCart(cart);
        const accepted = (cart.discount_codes || []).some((discount) => discount.code.toLowerCase() === code.toLowerCase() && discount.applicable);
        if (cartStatus) cartStatus.textContent = accepted ? 'تم تطبيق الخصم.' : 'الكود غير صالح أو غير متاح للمنتجات الحالية. بعض الخصومات تتحدد عند إتمام الطلب.';
      } catch (error) { if (cartStatus) cartStatus.textContent = error.message; }
      finally { cartBusy = false; if (button) button.disabled = false; }
    }
  });
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refreshCart().catch(() => {}); });
  window.addEventListener('pageshow', () => refreshCart().catch(() => {}));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeCart(); closeFilter();
      document.querySelectorAll('.mega[open]').forEach((menu) => { menu.open = false; });
      document.querySelectorAll('[data-predictive-results]').forEach((node) => { node.hidden = true; });
    }
    const activePanel = dialog && !dialog.hidden ? dialog : document.querySelector('[data-filter-panel].open');
    if (event.key !== 'Tab' || !activePanel) return;
    const focusable = Array.from(activePanel.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea')).filter((node) => node.getClientRects().length > 0);
    const first = focusable[0]; const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
  });
  let filterOpener;
  function closeFilter() {
    document.querySelector('[data-filter-panel]')?.classList.remove('open');
    document.querySelector('[data-filter-backdrop]')?.classList.remove('open');
    document.querySelector('[data-filter-open]')?.setAttribute('aria-expanded', 'false');
    lock();
    if (filterOpener) { filterOpener.focus(); filterOpener = null; }
  }
  document.addEventListener('click', (event) => {
    const open = event.target.closest('[data-filter-open]');
    if (open) {
      filterOpener = open;
      document.querySelector('[data-filter-panel]')?.classList.add('open');
      document.querySelector('[data-filter-backdrop]')?.classList.add('open');
      open.setAttribute('aria-expanded', 'true');
      lock();
      document.querySelector('[data-filter-close]')?.focus();
    }
    if (event.target.closest('[data-filter-close], [data-filter-backdrop]')) closeFilter();
    const thumbnail = event.target.closest('[data-product-image]');
    const image = document.getElementById('ProductImage');
    if (thumbnail && image) { image.src = thumbnail.dataset.productImage; image.removeAttribute('srcset'); }
  });
  document.querySelectorAll('[data-sort]').forEach((select) => select.addEventListener('change', () => select.form?.requestSubmit()));
  const variantsNode = document.querySelector('[data-variants]');
  const variants = variantsNode ? JSON.parse(variantsNode.textContent || '[]') : [];
  document.querySelector('[data-variant-select]')?.addEventListener('change', (event) => {
    const variant = variants.find((item) => String(item.id) === event.target.value);
    if (!variant) return;
    const price = document.querySelector('[data-product-price]');
    const compare = document.querySelector('[data-product-compare]');
    if (price) price.textContent = money(variant.price);
    if (compare) { compare.hidden = !(variant.compare_at_price > variant.price); compare.textContent = money(variant.compare_at_price || 0); }
    const button = document.querySelector('[data-product-add]');
    if (button) { button.disabled = !variant.available; button.textContent = variant.available ? 'أضف للسلة' : 'نفذت الكمية'; }
    const image = document.getElementById('ProductImage');
    if (image && variant.featured_image?.src) { image.src = variant.featured_image.src; image.removeAttribute('srcset'); }
    const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
  });
  document.querySelectorAll('[data-predictive]').forEach((input) => {
    let timer; let controller;
    const results = input.closest('.header-search')?.querySelector('[data-predictive-results]');
    input.addEventListener('input', () => {
      clearTimeout(timer); controller?.abort();
      if (!results) return;
      const query = input.value.trim();
      if (query.length < 2) { results.hidden = true; return; }
      timer = setTimeout(async () => {
        controller = new AbortController();
        try {
          const data = await api(`search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`, { signal: controller.signal });
          const products = data.resources?.results?.products || [];
          results.innerHTML = products.length ? products.map((product) => `<a href="${escapeHTML(product.url)}">${product.image ? `<img src="${escapeHTML(product.image)}" alt="" width="44" height="44">` : ''}<span>${escapeHTML(product.title)}</span></a>`).join('') : '<p>مفيش نتائج</p>';
          results.hidden = false;
        } catch { results.hidden = true; }
      }, 250);
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.header-search').forEach((search) => { if (!search.contains(event.target)) search.querySelector('[data-predictive-results]')?.setAttribute('hidden', ''); });
  });

  function estimate(amount, months) {
    if (!Number.isFinite(amount) || !Number.isFinite(months) || amount <= 0 || months <= 0 || !Number.isInteger(months)) return null;
    const interest = amount * 0.3 * months / 12;
    return { interest, total: amount + interest, monthly: (amount + interest) / months };
  }
  const calculator = document.querySelector('[data-calculator]');
  if (calculator) {
    const update = () => {
      const amount = Number(calculator.querySelector('[data-calc-amount]')?.value);
      const months = Number(calculator.querySelector('[data-calc-months]')?.value);
      const budgetInput = calculator.querySelector('[data-calc-budget]');
      const budget = budgetInput?.value === '' ? null : Number(budgetInput?.value);
      const result = estimate(amount, months);
      const validBudget = budget === null || (Number.isFinite(budget) && budget > 0);
      calculator.querySelector('[data-calc-monthly]').textContent = result ? money(result.monthly * 100) : '—';
      calculator.querySelector('[data-calc-total]').textContent = result ? money(result.total * 100) : '—';
      calculator.querySelector('[data-calc-interest]').textContent = result ? money(result.interest * 100) : '—';
      calculator.querySelector('[data-calc-status]').textContent = !result || !validBudget ? 'أدخل سعرًا صحيحًا وعدد شهور صحيحًا وميزانية أكبر من صفر.' : (budget !== null && result.monthly > budget ? 'القسط التقديري أعلى من ميزانيتك.' : 'تقدير فقط، وليس عرض تمويل معتمدًا.');
      const items = document.querySelectorAll('[data-budget-price]');
      let visible = 0;
      items.forEach((item) => { const cost = estimate(Number(item.dataset.budgetPrice), months); item.hidden = !(validBudget && cost && (budget === null || cost.monthly <= budget)); if (!item.hidden) visible++; });
      const empty = document.querySelector('[data-budget-empty]');
      if (empty) empty.hidden = visible > 0;
    };
    calculator.addEventListener('input', update); update();
  }
  document.querySelectorAll('[data-countdown]').forEach((node) => {
    const deadline = Date.parse(node.dataset.countdown);
    if (!Number.isFinite(deadline)) return;
    const tick = () => {
      const remaining = Math.max(0, deadline - Date.now());
      if (!remaining) { node.hidden = true; clearInterval(timer); return; }
      node.hidden = false;
      const hours = Math.floor(remaining / 3600000); const minutes = Math.floor(remaining / 60000) % 60; const seconds = Math.floor(remaining / 1000) % 60;
      node.innerHTML = `<span>${String(hours).padStart(2, '0')}</span>:<span>${String(minutes).padStart(2, '0')}</span>:<span>${String(seconds).padStart(2, '0')}</span>`;
    };
    const timer = setInterval(tick, 1000); tick();
  });
})();